import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const phoneNumber = '919766601155';
  const message = encodeURIComponent('Hello! I would like to inquire about scaffolding hire.');

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-20 lg:bottom-6 right-4 lg:right-6 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#10B981] animate-ping opacity-30"></span>
      <span className="relative flex items-center justify-center w-14 h-14 bg-[#10B981] text-black rounded-full shadow-2xl shadow-[#10B981]/30 hover:scale-110 transition-transform">
        <MessageCircle size={26} strokeWidth={2.4} />
      </span>
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 hidden lg:flex items-center gap-2 bg-black/90 border border-white/10 text-white px-3 py-2 rounded-sm text-xs font-mono uppercase tracking-widest whitespace-nowrap opacity-0 group-hover:opacity-100 transition pointer-events-none">
        <span className="w-1.5 h-1.5 bg-[#10B981] rounded-full"></span> Chat on WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppButton;
